import { ApiResourceBaseClass as a } from "./baseApiCalls.js";
const s = "reviews";
class i extends a {
  async getWrongGmbLocationCount(t) {
    const { data: e } = await this.get(
      `${s}/get_wrong_gmb_location_count`,
      {
        business_id: t
      }
    );
    return e;
  }
  async cleanGmbReviews(t) {
    const { data: e } = await this.post(
      `${s}/clean_gmb_reviews`,
      {
        business_id: t
      }
    );
    return e;
  }
}
export {
  i as ReviewAdmin
};
